/* Luminous Field product presentation. Commerce remains in hsx-offers.js. */
(() => {
  'use strict';
  if (!customElements.get('hsx-premium-gallery')) {
    customElements.define('hsx-premium-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.track = this.querySelector('[data-hsxu-track]');
        this.slides = [...this.querySelectorAll('[data-hsxu-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-hsxu-thumb]')];
        if (!this.track || !this.slides.length) return;
        this.index = 0;
        this.frame = 0;
        this.previous = this.querySelector('[data-hsxu-previous]');
        this.next = this.querySelector('[data-hsxu-next]');
        this.count = this.querySelector('[data-hsxu-count]');
        this.thumbs.forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.hsxuThumb)), options));
        this.previous?.addEventListener('click', () => this.go(this.index - 1), options);
        this.next?.addEventListener('click', () => this.go(this.index + 1), options);
        this.track.addEventListener('scroll', () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.index = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))));
            this.sync();
          });
        }, {...options, passive: true});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const targets = {ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1};
          if (!(event.key in targets)) return;
          event.preventDefault(); this.go(targets[event.key]);
        }, options);
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(() => this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: 'instant'}));
          this.resize.observe(this.track);
        }
        this.querySelector('[data-hsxu-controls]').hidden = false;
        this.dataset.enhanced = 'true';
        this.sync();
      }
      go(index) {
        const next = Math.min(this.slides.length - 1, Math.max(0, index));
        this.index = next;
        this.sync();
        this.track.scrollTo({left: next * this.track.clientWidth, behavior: 'instant'});
      }
      sync() {
        this.thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
        this.slides.forEach((slide, i) => { slide.inert = i !== this.index; });
        if (this.previous) this.previous.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
        if (this.count) this.count.textContent = (this.index + 1) + ' / ' + this.slides.length;
      }
      disconnectedCallback() {
        this.controller?.abort(); this.controller = null;
        this.resize?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.slides?.forEach(slide => { slide.inert = false; });
      }
    });
  }

  let dispose = null;
  function navigation() {
    dispose?.();
    const product = document.querySelector('[data-hsx-premium-product]');
    if (!product || !('IntersectionObserver' in window)) return;
    const html = document.documentElement;
    html.classList.add('hsxe-navigation-ready');
    const hero = new IntersectionObserver(entries => {
      const entry = entries[0];
      html.dataset.hsxeExploring = String(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {rootMargin: '-160px 0px 0px 0px'});
    hero.observe(product);
    const footer = document.querySelector('.hsx-v2-footer');
    const foot = new IntersectionObserver(entries => { html.dataset.hsxuFooterVisible = String(entries[0].isIntersecting); });
    if (footer) foot.observe(footer);
    const links = [...document.querySelectorAll('.hsxv-jump a[href^="#"]')];
    const chapter = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) links.forEach(link => {
        if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }, {rootMargin: '-25% 0px -60% 0px'});
    links.forEach(link => { const section = document.getElementById(link.hash.slice(1)); if (section) chapter.observe(section); });
    dispose = () => {
      hero.disconnect(); foot.disconnect(); chapter.disconnect();
      html.classList.remove('hsxe-navigation-ready');
      delete html.dataset.hsxeExploring; delete html.dataset.hsxuFooterVisible;
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', navigation, {once:true});
  else navigation();
  document.addEventListener('shopify:section:load', navigation);
  document.addEventListener('shopify:section:unload', event => { if (event.target.querySelector('[data-hsx-premium-product]')) dispose?.(); });
})();
